class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    // MODIFIED: If term is empty, fetch default bundles instead of closing
    if (!this.searchTerm.length) {
      this.getSearchResults(" "); 
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    // MODIFIED: If user clicks empty bar, show default bundles immediately
    if (!currentSearchTerm.length) {
      this.getSearchResults(" ");
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onKeyup(event) {
    // MODIFIED: Don't close when backspacing to empty; fetch bundles instead
    if (!this.getQuery().length) {
      this.getSearchResults(" ");
    }
    
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  // ... (Rest of the original methods like getSearchResults, renderSearchResults, etc. remain the same)
  
  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) return;
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }
  
  // ... (Include other helper methods from your original code)
  onFormSubmit(event) { if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault(); }
  onFocusOut() { setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }); }
  onKeydown(event) { if (event.code === 'ArrowUp' || event.code === 'ArrowDown') event.preventDefault(); }
  updateSearchForTerm(previousTerm, newTerm) { /* ... original logic ... */ }
  switchOption(direction) { /* ... original logic ... */ }
  selectOption() { /* ... original logic ... */ }
  setLiveRegionLoadingState() { /* ... original logic ... */ }
  setLiveRegionText(statusText) { /* ... original logic ... */ }
  setLiveRegionResults() { /* ... original logic ... */ }
  getResultsMaxHeight() { /* ... original logic ... */ }
  open() { 
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }
  close(clearSearchTerm = false) { this.closeResults(clearSearchTerm); this.isOpen = false; }
  closeResults(clearSearchTerm = false) { /* ... original logic ... */ }
}

customElements.define('predictive-search', PredictiveSearch);

document.addEventListener('click', function(event) {
  // Check if the user clicked the toggle button
  const toggleButton = event.target.closest('.js-bundle-toggle');

  if (toggleButton) {
    // IMPORTANT: Stop navigation and stop search from closing
    event.preventDefault();
    event.stopPropagation();

    const wrapper = toggleButton.closest('.bundle-wrapper');
    const innerContent = wrapper.querySelector('.bundle-inner-content');
    const textSpan = toggleButton.querySelector('.toggle-text');
    const count = toggleButton.getAttribute('data-count');
    
    // Toggle Logic
    const isHidden = innerContent.style.display === 'none' || innerContent.style.display === '';
    
    if (isHidden) {
      innerContent.style.display = 'block';
      textSpan.innerText = `Hide items`;
      toggleButton.style.background = '#000';
      toggleButton.style.color = '#fff';
    } else {
      innerContent.style.display = 'none';
      textSpan.innerText = `Show ${count} items`;
      toggleButton.style.background = '#f8f8f8';
      toggleButton.style.color = '#555';
    }
  }
});